<template>
  <div class="contratar">
    <Header :data="headerData" />
    <FormContratar :data="data" />
    <Footer />
  </div>
</template>

<script>
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import FormContratar from "../components/contratar/FormContratar";

export default {
  name: "Contratar",
  components: {
    Header,
    FormContratar,
    Footer,
  },
  metaInfo: {
    title: "Contratar Plan",
  },
  beforeCreate() {
    if (!this.$route.params.allData) {
      this.$router.push({
        name: "Home",
        params: {},
      });
    }
  },
  data() {
    return {
      headerData: {
        logo: "plan-gracias",
        menu: [
          { type: "to", to: "/", text: "Iniciar cotizador" },
          {
            type: "href",
            href: "https://www.osfatun.com.ar/",
            text: "Ir al sitio web",
          },
        ],
      },
      data: {
        personData: this.$route.params.allData,
        planType: this.$route.params.thisType,
        firstPrice: this.$route.params.firstPrice,
      },
    };
  },
};
</script>

<style scoped></style>
